import React from 'react';
import { useNavigate } from 'react-router-dom';
import DownloadIcon from '@mui/icons-material/Download';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

interface Relatorio {
  titulo: string;
  descricao: string;
  rota: string;
}

const relatorios: Relatorio[] = [
  {
    titulo: 'Patrimônio Líquido por Fundo',
    descricao: 'Histórico completo de Patrimônio Líquido de um fundo selecionado em formato Excel, com data, PL, quantidade, valor por unidade e resultado do dia.',
    rota: '/relatorios/pl-fundos',
  },
];

const Relatorios: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div>
      <h2>Relatórios</h2>
      <p style={{ color: '#4D5766', marginBottom: '28px' }}>
        Selecione um relatório para visualizar ou baixar.
      </p>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', maxWidth: '720px' }}>
        {relatorios.map((r) => (
          <div
            key={r.rota}
            onClick={() => navigate(r.rota)}
            style={{
              background: '#FFFFFF',
              border: '1px solid #CFD8E5',
              borderRadius: '12px',
              padding: '20px 24px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '16px',
              boxShadow: '0 1px 3px rgba(29,29,38,0.05)',
              transition: 'box-shadow 0.15s ease, border-color 0.15s ease',
            }}
            onMouseEnter={e => {
              (e.currentTarget as HTMLDivElement).style.boxShadow = '0 4px 12px rgba(44,145,173,0.12)';
              (e.currentTarget as HTMLDivElement).style.borderColor = '#2C91AD';
            }}
            onMouseLeave={e => {
              (e.currentTarget as HTMLDivElement).style.boxShadow = '0 1px 3px rgba(29,29,38,0.05)';
              (e.currentTarget as HTMLDivElement).style.borderColor = '#CFD8E5';
            }}
          >
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
              <div style={{
                width: '44px',
                height: '44px',
                borderRadius: '10px',
                background: '#EEF7FA',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}>
                <DownloadIcon style={{ color: '#2C91AD', fontSize: '22px' }} />
              </div>
              <div>
                <div style={{ fontWeight: 600, fontSize: '14px', color: '#1D1D26', marginBottom: '4px' }}>
                  {r.titulo}
                </div>
                <div style={{ fontSize: '13px', color: '#4D5766', lineHeight: 1.5 }}>
                  {r.descricao}
                </div>
              </div>
            </div>
            <ArrowForwardIcon style={{ color: '#2C91AD', flexShrink: 0 }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Relatorios;
